module.exports = __webpack_public_path__ + "static/media/zhinenghua.b1092f94.png";